
const getTransactionList = async (mvcmydashboard) => {
	var  list = [];

	let sessionuuid = await mvcmydashboard.getCurrentSession();
	let bRefresh = true;
	let transactions = await mvcmydashboard.getEthereumTransactions(sessionuuid, bRefresh).catch(err => {});

	for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
		let transaction = transactions[i];
		let record = {id: transaction.uuid, uuid: transaction.uuid,
			transactionhash: transaction.transactionhash,
			unixdate: transaction.unixdate, date: transaction.date,
			from: transaction.from, to: transaction.to,
			value: (transaction.value ? transaction.value : '0'),
			status: transaction.status };

		list.push(record);
	}

	return list;
};


export default {
	getFullList: async (mvcmydashboard) => {
		let list = [];

		if (!mvcmydashboard) return list;

		list = await getTransactionList(mvcmydashboard);

		return list;
	},

	getMany: async (mvcmydashboard, params) => {
		throw new Error('getMany not implemented');
	},

	getManyReference: async (mvcmydashboard, params) => {
		throw new Error('getManyReference not implemented');
	},

	update: async (mvcmydashboard, params) => {
		throw new Error('update not implemented');
	},

	updateMany: async (mvcmydashboard, params) => {
		throw new Error('updateMany not implemented');
	},

	create: async (mvcmydashboard, params) => {
		throw new Error('create not implemented');
	},

	delete: async (mvcmydashboard, params) => {
		throw new Error('delete not implemented');
	},

	deleteMany: async (mvcmydashboard, params) => {
		throw new Error('deleteMany not implemented');
	},
};